import styled from "styled-components";

import { COLOR_VALUES } from "shared/config/colors";
import TertiaryButton from "shared/components/inputs/button/TertiaryButton";

export const StyledTertiaryButton = styled(TertiaryButton)`
    box-shadow: 0 0 0px 1px ${COLOR_VALUES.Gray_6} inset;
    padding: 0;
    min-height: 16px;
    width: 16px;
    height: 16px;
    border-radius: 50% !important;
    align-items: center;

    svg {
        width: 12px;
        height: 12px;
    }
`;
